import React, { useEffect, useState } from "react";
import { Table, Tag, Tooltip } from "antd";
import "./index.css";
import moment from "moment";
import { Typography } from "antd";
import QuestionTextProvider from "Components/CommonComponents/QuestionTextProvider";
import PropTypes from "prop-types";
const { Paragraph } = Typography;
export const formatDate = (date) => {
  // Format the date using moment.js
  return moment(date).format("DD-MM-YY, hh:mm a");
};
export const getAppendImgUrl = (text) => {
  const myRegex = /<img[^>]+src="?([^"\s]+)"?\s*>/g;
  const url = myRegex.exec(text);
  // const s3BaseURL = imageUrl
  let newText = text;
  if (url && url.length > 0 && url[1].indexOf("s3") === -1) {
    const appendBaseURL = url[1];
    newText = text.replace(url[1], appendBaseURL);
  }
  return newText;
};
export const returnStatusColor = (status) => {
  let color = "orange";
  if (status == "Create") {
    color = "purple";
  } else if (status == "Draft") {
    color = "magenta";
  } else if (status == "Proofread") {
    color = "orange";
  } else if (status == "Proofreading") {
    color = "orange";
  } else if (status == "Review") {
    color = "gold";
  } else if (status == "Approved") {
    color = "green";
  } else if (status == "Published") {
    color = "geekblue";
  } else if (status == "Unpublished") {
    color = "red";
  } else if (status == "Deactivated") {
    color = "gray";
  } else if (status == "TBP") {
    color = "volcano";
  } else if (status == "Open") {
    color = "lime";
  } else if (status == "Done") {
    color = "cyan";
  } else if (status == "Recheck") {
    color = "orange";
  } else if (status == "Reassign") {
    color = "blue";
  } else if (status == "Verified") {
    color = "green";
  } else if (status == "UnVerified") {
    color = "volcano";
  } else if (status == "N/A") {
    color = "";
  }

  return color;
};
const QuestionsTable = (props) => {
  const {
    data,
    pagination,
    setPagination,
    tablecolumns,
    handleIdsClick,
    selectedQuesInSide,
  } = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState(
    selectedQuesInSide != null ? [selectedQuesInSide?.questionId] : []
  );
  // const navigate = useNavigate();

  useEffect(() => {
    if (selectedQuesInSide && selectedQuesInSide != null) {
      setSelectedRowKeys([selectedQuesInSide?.questionId]);
    }
  }, [selectedQuesInSide]);

  const columns = [
    {
      title: "Question ID",
      dataIndex: "questionId",
      key: "questionId",
      fixed: "left",
      sorter: true,
      width: 110,
      render: (_, record) => {
        return (
          <Paragraph
            className="tableIdStyle"
            editable={false}
            copyable={false}
            onClick={() => {
              handleIdsClick(record);
              setSelectedRowKeys([record.questionId]);
            }}
          >
            {record.questionId}
          </Paragraph>
        );
      },
    },
    {
      title: "External ID",
      dataIndex: "questionExternalId",
      key: "questionExternalId",
      sorter: true,
      render: (questionExternalId) => {
        return (
          <Tooltip title={questionExternalId}>
            <Paragraph copyable>{questionExternalId}</Paragraph>
          </Tooltip>
        );
      },
    },
    {
      title: "Question Content",
      dataIndex: "questionText",
      key: "questionText",
      ellipsis: true,
      width: "auto",
      // classname: 'questiontexttableColumn',
      render: (_, record) => {
        return (
          <div
            className={"questiontexttableColumnAIHint"}
            onClick={() => {
              handleIdsClick(record);
              setSelectedRowKeys([record.questionId]);
            }}
          >
            {record?.questionText && record.questionText != null ? (
              <QuestionTextProvider
                content={getAppendImgUrl(record.questionText)}
              />
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "questionType",
      key: "questionType",
    },
    {
      title: "Marks",
      dataIndex: "marks",
      key: "marks",
      sorter: true, // Enable sorting by marks
    },
    {
      title: "WF Status",
      key: "workflowStatus",
      dataIndex: "workflowStatus",
      render: (_, { workflowStatus }) => {
        return (
          <Tag
            bordered={false}
            color={returnStatusColor(workflowStatus)}
            key={workflowStatus}
          >
            {workflowStatus == "N/A" ? "-" : workflowStatus.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Updated On",
      dataIndex: "questionUpdatedAt",
      key: "questionUpdatedAt",
      sorter: true, // Enable sorting by date
      render: (questionUpdatedAt) => formatDate(questionUpdatedAt),
    },
    {
      title: "Status",
      key: "questionStatus",
      dataIndex: "questionStatus",
      fixed: "right",
      render: (_, { questionStatus }) => {
        return (
          <Tag color={returnStatusColor(questionStatus)} key={questionStatus}>
            {questionStatus.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Hint Status",
      key: "hintStatus",
      dataIndex: "hintStatus",
      fixed: "right",
      render: (_, record) => {
        return record.tags != null ? (
          <Tag
            color={returnStatusColor(
              record.tags.includes("HV") ? "Verified" : "UnVerified"
            )}
            key={record.tags.includes("HV") ? "Verified" : "UnVerified"}
          >
            {record.tags.includes("HV") ? "Verified" : "Unverified"}
          </Tag>
        ) : (
          <span>-</span>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 60,
    },
  ];

  const handleTableChange = (pagination, sorter) => {
    const sortField = sorter?.columnKey
      ? sorter?.columnKey
      : pagination.sortField
      ? pagination.sortField
      : "updatedAt";
    const sortOrder = sorter?.order
      ? sorter?.order === "ascend"
        ? "ASC"
        : "DESC"
      : pagination.sortOrder;

    setPagination((prevPagination) => ({
      ...prevPagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
      sortField,
      sortOrder,
    }));
  };
  const onSelectChange = (record) => {
    handleIdsClick(record);
  };
  const onSelectionChange = (selectedRows) => {
    setSelectedRowKeys(selectedRows);
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: onSelectionChange,
    hideSelectAll: true,
    type: "radio",
    onSelect: onSelectChange,
  };

  return (
    <Table
      className="questionTablePAdding"
      columns={columns.filter((el) => tablecolumns.includes(el.dataIndex))}
      dataSource={data}
      scroll={{ x: "max-content" }}
      pagination={pagination}
      onChange={handleTableChange}
      bordered
      size="small"
      rowKey={"questionId"}
      rowSelection={rowSelection}
      // rowClassName={rowClassName}
    />
  );
};
QuestionsTable.propTypes = {
  data: PropTypes.any,
  pagination: PropTypes.object,
  setPagination: PropTypes.func,
  tablecolumns: PropTypes.any,
  handleIdsClick: PropTypes.func,
  selectedQuesInSide: PropTypes.any,
};
export default QuestionsTable;
